import { render, staticRenderFns } from "./app-tab-bar.vue?vue&type=template&id=b5850248&scoped=true&"
import script from "./app-tab-bar.vue?vue&type=script&lang=js&"
export * from "./app-tab-bar.vue?vue&type=script&lang=js&"
import style0 from "./app-tab-bar.vue?vue&type=style&index=0&id=b5850248&lang=scss&scoped=true&"
import style1 from "./app-tab-bar.vue?vue&type=style&index=1&id=b5850248&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5850248",
  null
  
)

export default component.exports